import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { basename, user } from './i18n';
import AppLayout from './layout/AppLayout';
import Dashboard from './pages/Dashboard';
import PlaceEdit from './pages/PlaceEdit';
import Reviews from './pages/Reviews';
import Login from './pages/Login';

/** Redirige vers /login si la session n'est pas authentifiée. */
function RequireAuth({ children }) {
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

export default function App() {
    return (
        <BrowserRouter basename={basename}>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route element={<RequireAuth><AppLayout /></RequireAuth>}>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/edit/:id" element={<PlaceEdit />} />
                    <Route path="/commentaires/:id" element={<Reviews />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
}
